<template>
  <span
    class="py-1 px-2 bg-[#EDE9E3] font-normal text-[0.875rem] leading-[1.25rem] text-[#334155] rounded"
  >
    {{ tag }}
  </span>
</template>
<script>
export default {
  name: 'Tag',
  props: {
    tag: {
      type: String,
      required: true
    }
  }
}
</script>